import React from 'react';
// import './faqs.scss';
import Accordion from 'react-bootstrap/Accordion';

const Faqscreateprofile = () => {
  const faqData = [
    {
      question: "What is the Create Profiles feature, and why should I use it?",
      answer:
        "The Create Profiles feature allows users to build a personalized profile within the TOMI app. It helps enhance interactions by showcasing details such as your name, bio, interests, and professional links.",
    },
    {
      question: "What can I include in my profile?",
      answer:
        "You can add a profile picture, name, bio, interests, links, and other relevant details to personalize your presence on the platform.",
    },
    {
      question: "Can I adjust who sees my profile?",
      answer:
        "Yes! You have full control over your profile visibility. You can choose to make it public, private, or visible only to selected contacts.",
    },
    {
      question: "Can I use my profile for professional purposes?",
      answer:
        "Absolutely! Your profile can be customized to include professional details, making it easier for networking and business connections.",
    },
    {
      question: "What makes this profile different from social media profiles?",
      answer:
        "Unlike traditional social media profiles, TOMI profiles are designed for secure interactions, decentralized payments, and privacy-focused networking.",
    },
    {
      question: "How does my profile integrate with other features?",
      answer:
        "Your profile seamlessly integrates with chat, payments, and networking features, allowing a unified and smooth user experience.",
    },
    {
      question: "Can I update my profile later?",
      answer:
        "Yes, you can edit and update your profile details anytime through the settings section.",
    },
    {
      question: "What happens if I don’t create a profile?",
      answer:
        "You can still use basic app features, but creating a profile enhances your experience by enabling personalized interactions and additional functionalities.",
    },
    {
      question: "Are profiles public or private by default?",
      answer:
        "By default, profiles are set to private. Users can customize visibility settings as per their preferences.",
    },
    {
      question: "Can I link my profile to external platforms?",
      answer:
        "Yes, you can add links to external websites, social media accounts, or portfolios for greater connectivity.",
    },
  ];

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqData.map((faq) => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer,
      },
    })),
  };

  return (
    <section className="faqsmainprnt">
      <div className="postionfaqs">
        <img className="img-fluid" src="/assets/faqpositionimg.png" alt="FAQ Section" />
      </div>
      <div className="custom-container">
        <div className="faqschldmain">
          <h2>FAQ</h2>
          <div className="faqscustumdesigine">
            <div className="accordion" id="accordionExample">
              {faqData.map((faq, index) => (
                <div className="accordion-item" key={index}>
                  <h3 className="accordion-header">
                    <button
                      className={`accordion-button ${index !== 0 ? "collapsed" : ""}`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapse${index}`}
                      aria-expanded={index === 0 ? "true" : "false"}
                      aria-controls={`collapse${index}`}
                    >
                      <div className="btninner">{faq.question}</div>
                    </button>
                  </h3>
                  <div
                    id={`collapse${index}`}
                    className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <div className="bodymain"><span>{faq.answer}</span></div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
    </section>
  );
};

export default Faqscreateprofile;
